import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  remember(event) {
    const pane = event.target.getAttribute("data-bs-target")
    if (!pane?.startsWith("#")) return

    const url = new URL(window.location.href)
    const paneId = pane.slice(1)
    const tab = {
      "athletes-div": "s",
      "concussion_events-div": "i",
      "assessments-div": "a",
      "dashboard-div": "b",
      "insight-div": "e",
      "my-users-div": "c",
      "users-div": "u",
      "details-div": "d"
    }[paneId]
    if (!tab) return

    if (tab === "s") {
      url.searchParams.delete("t")
    } else {
      url.searchParams.set("t", tab)
    }
    url.searchParams.delete("tab")
    url.searchParams.delete("active_tab")
    window.history.replaceState(window.history.state, "", url)
  }
}
